import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../adapter-vue";
import { isPC } from "../../../utils/env";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-button',
  props: {
  enableSend: {
    type: Boolean,
    default: true,
  },
},
  emits: ["sendMessage"],
  setup(__props, { emit: emits }) {

const props = __props




const sendMessage = () => {
  emits("sendMessage");
};

return { __sfc: true,props, emits, sendMessage, TUITranslateService, isPC }
}

})